export const convertNumToUSD = (num = 0, minimumFractionDigits = 0, maximumFractionDigits = 2) => {
    return parseFloat(num).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits,
        minimumFractionDigits,
    });
};

export const convertNumToCredits = (num = 0, minimumFractionDigits = 0, maximumFractionDigits = 2) => {
    return parseFloat(num).toLocaleString('en-US', {
        style: 'decimal',
        maximumFractionDigits,
        minimumFractionDigits,
    });
};

export const showPrice = (price, minimumFractionDigits) => {
    // const myCountry = getCountry();
    const isFromForeign = false; // myCountry !== 1 || foreign;
    return `${convertNumToUSD(price, minimumFractionDigits)}${isFromForeign ? ' USD' : ''}`;
};

export const showPriceCredits = (price, minimumFractionDigits) => {
    const num = parseFloat(price);
    const creditText = num == 1 || num == -1 ? 'credit' : 'credits';
    return `${convertNumToCredits(price, minimumFractionDigits)} ${creditText}`;
};

export const numFormatter = (num = 0) => {
    return new Intl.NumberFormat('en-US').format(num);
};
